import { useParams, Navigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { useGetCampaigns } from 'features/campaigns/campaigns_api'
import { WORKFLOW_STATUS } from 'models/campaign'

const DETAIL_STATUSES: string[] = [
  WORKFLOW_STATUS.DRAFT,
  WORKFLOW_STATUS.CONTACTS_REQUESTED,
  WORKFLOW_STATUS.READY_TO_LAUNCH,
]

export function CampaignRouterPageV2() {
  const { campaign_id } = useParams<{ campaign_id: string }>()
  const { data: campaignsResponse, isLoading } = useGetCampaigns()

  // When flag is ON, fetch campaign and redirect based on status
  const campaigns = campaignsResponse?.results || []
  const campaign = campaigns.find((c) => c.id === Number(campaign_id))

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner animation="border" />
      </div>
    )
  }

  if (!campaign) {
    return <Navigate to="/campaigns" replace />
  }

  if (DETAIL_STATUSES.includes(campaign.workflow_status as string)) {
    return <Navigate to={`/campaigns/${campaign_id}/detail`} replace />
  }

  return <Navigate to={`/campaigns/${campaign_id}/dashboard`} replace />
}
